import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import SideBarMenu from "../MUI/SideBarMenu";
import { MoreVert } from "@material-ui/icons";
import { Box, Paper, Divider, AppBar, Toolbar } from "@material-ui/core";
import { pink } from '@material-ui/core/colors';


const styles = theme => ({
	root: {
		width: "100%",
	},
	sectionDesktop: {
		width: "100%",
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex"
		}
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none"
		}
	},
	nav: {
		margin: "auto",
		maxWidth: 1400,
		display: 'flex',
		justifyContent: "space-between",
		// backgroundColor: "white"

	},

	menuButton: {
		marginLeft: -12,
		marginRight: 20
	},

	button: {
		margin: theme.spacing(1)
	},
	buttonNav: {
		padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
		height: "100%",
		borderRadius: 0,
	},
	
	navTitle: {
		height: 40,
		margin: "-8px auto",
		width: 140,
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		margin: "auto",
		textAlign: "center",
		maxWidth: 1400,
		height: 40,
		display: 'flex',
		justifyContent: "center",

	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},
	toolbar: theme.mixins.toolbar,
	list: {
		width: 250,
	},
	fullList: {
		width: 'auto',
	},
	primary: {
		color: theme.palette.getContrastText(theme.palette.primary.light),
		backgroundColor: theme.palette.primary.light,
	},
	secondary: {
		color: theme.palette.getContrastText(theme.palette.secondary.light),
		backgroundColor: theme.palette.secondary.light,
	},
	lightPink: {
		color: theme.palette.getContrastText(pink[200]),
		backgroundColor: pink[200],
	},
	black: {
		color: "white",
		backgroundColor: "black",
	},
});
const drawerWidth = 240;

class Header extends React.Component {
	state = {
		anchorEl: null,
		mobileMoreAnchorEl: null
	};
	handleProfileMenuOpen = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleLogout = () => {
		localStorage.removeItem("token_8000");
		localStorage.removeItem("userInfo_8000");
		localStorage.removeItem("accessList_8000");
		localStorage.removeItem("tokenMG");

		this.handleMenuClose()
	};
	handleMenuClose = () => {
		this.setState({ anchorEl: null });
		this.handleMobileMenuClose();
	};

	handleMobileMenuOpen = event => {
		this.setState({ mobileMoreAnchorEl: event.currentTarget });
	};

	handleMobileMenuClose = () => {
		this.setState({ mobileMoreAnchorEl: null });
	};
	goToHomePage = () => {
		console.log("GO TO MENU");

		// history.push("/");
	}
	render() {
		const { anchorEl } = this.state;
		const { classes } = this.props;
		const isMenuOpen = Boolean(anchorEl);
		// const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
		

		const userMenu = (
			<Menu
				anchorEl={anchorEl}
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				open={isMenuOpen}
				onClose={this.handleMenuClose}
			>
				{this.props.userApp &&
					// <Link to={"/profile/dashboard"} >
						<ListItem
							onClick={() => {
								this.props.handleUserProfile("UserProfile")
								this.handleMenuClose() }
							}
						>
							<ListItemText>
								Profile							
							</ListItemText>
						</ListItem>
					// </Link>
				}
				<Fragment>
					<ListItem
						onClick={this.handleMenuClose}
					>
						<ListItemText >
						Update
						</ListItemText>
					</ListItem>
					<ListItem
						onClick={this.handleMenuClose}
					>
						<ListItemText >
						Update version
						</ListItemText>
					</ListItem>
					<ListItem
						component="a"
						href="/adminpage/cli"
						onClick={this.handleMenuClose}
					>
						<ListItemText
							primary="CLI MyJouleBox"
							secondary="Autoriser un code & guide d'installation"
						/>
					</ListItem>
					<ListItem
						component="a"
						href="/logout/disconnect"
						onClick={this.handleLogout}
					>
						<ListItemText >
						Déconnexion

						</ListItemText>
					</ListItem>

				</Fragment>
			</Menu>
		);

		return (
			<AppBar color="primary">
				<Toolbar>
				
					<div >
						{/* <IconButton onClick={this.handleMobileMenuOpen} className={classes.menuButton} color="inherit" aria-label="Menu">
							<MenuIcon />
						</IconButton> */}
						<SideBarMenu {...this.props} links={this.props.page} />
					</div>

					<Box className={classes.navTitle}>
						<img src="../../../../../img/logo.png" className="img-responsive" alt="" onClick={this.goToHomePage} />
					</Box>
					
					<IconButton
						aria-owns={
							isMenuOpen
								? "material-appbar"
								: undefined
						}
						aria-haspopup="true"
						onClick={this.handleProfileMenuOpen}
						color="inherit"
					>
						<MoreVert />
					</IconButton>
					{userMenu}
				</Toolbar>					
			</AppBar>
		);
	}
}



export default withStyles(styles)(Header)
